export default {"src":"/_next/static/media/icon.01ff4003.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};